import Client from './client'

export default class Store {
    constructor(ref) {
        this.client = new Client()
        this.ref = ref
    }

    async update(uuid, data, opts = {}) {
        let { source = 'platform' } = opts

        return await this.client.http().post(`/v4/system/component/${this.ref}/model/${uuid}`, data, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async create(data, opts = {}) {
        let { source = 'platform' } = opts

        console.log("CREATE DATA", this.ref, data)

        return await this.client.http().post(`/v4/system/component/${this.ref}/model`, data, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async delete(uuid, opts = {}) {
        let { source = 'platform' } = opts

        return await this.client.http().delete(`/v4/system/component/${this.ref}/model/${uuid}`, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async getModelByUUID(uuid, opts = {}) {
        let { source = 'platform' } = opts
        
        return await this.client.http().get(`/v4/system/component/${this.ref}/model/${uuid}`, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async models(params, options = {}) {
        const { signal, ...restOptions } = options
        return await this.client.http().post(`/v4/system/component/${this.ref}/models`, {
            ...params,
            options: restOptions,
        }, { signal })
    }

    async getRevisions(modelUuid, opts = {}) {
        let { page = -1, source = 'platform' } = opts
        
        return await this.client.http().get(`/v3/system/component/${this.ref}/model/${modelUuid}/revisions`, {
            params: { page },
            headers: {
                'X-Source': source,
            }
        })
    }

    async restoreRevision(modelUuid, version, opts = {}) {
        let { source = 'platform' } = opts
        
        return await this.client.http().post(`/v3/system/component/${this.ref}/model/${modelUuid}/revision/restore`, {
            version: version
        }, {
            headers: {
                'X-Source': source,
            }
        })
    }
}